import { ContactUsConfig } from '@tenants/types';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export const contactUsConfig: ContactUsConfig = {
  title: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_TITLE,
  description: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_DESCRIPTION,
  notificationContent: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_NOTIFICATIONCONTENT,
  bottomContent: {
    title: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_BOTTOMCONTENT_TITLE,
    description: LOCALE_EXP_COMMERCIAL_PATHS.CONTACT_BOTTOMCONTENT_DESCRIPTION,
  },
  hubspotFormId: '62a2b4ba-a3c8-4521-b5b6-20181cd38b89',
};
